export default (state: any) => {
  return {
    ...state,
    uiSettings: {
      ...state.uiSettings,
      growthBook: {
        ...state.growthBook,
        featureFlagsEnabled: false,
      },
    },
  };
};
